import { IOrderApprovalHistoryHook } from '@models';
import { useStore } from '@stores';
import { useEffect, useState } from 'react';

interface IProps {
  orderId?: string;
  customerId?: string;
  registrationNumber?: string;
}

export const useOrderApprovalHistory = ({
  orderId,
  customerId,
  registrationNumber,
}: IProps): IOrderApprovalHistoryHook => {
  const { orderStore } = useStore();
  const {
    approvalHistory,
    approvalHistoryTotalCount,
    approvalHistoryCurrentPage,
    approvalHistorySkipCount,
    approvalHistoryMaxResultCount,
    approvalHistoryLoading,
    handleApprovalHistoryPageChange,
  } = orderStore;

  // ABP sorting expression from the table's date column, e.g. 'CreationTime DESC'.
  const [sorting, setSorting] = useState<string | undefined>();

  useEffect(() => {
    return () => orderStore.resetApprovalHistory();
  }, [orderStore]);

  useEffect(() => {
    const hasFilter = orderId || (customerId && registrationNumber);
    if (!hasFilter) return;

    orderStore.getApprovalHistory({
      orderId,
      customerId,
      vrm: registrationNumber,
      skipCount: approvalHistorySkipCount,
      maxResultCount: approvalHistoryMaxResultCount,
      sorting,
    });

    return () => {
      orderStore.clearApprovalHistory();
    };
  }, [orderStore, orderId, customerId, registrationNumber, approvalHistorySkipCount, approvalHistoryMaxResultCount, sorting]);

  const handleSortChange = (value?: string) => {
    setSorting(value);
    // Back to page one - a re-ordered list makes the page number meaningless.
    handleApprovalHistoryPageChange({ current: 1, pageSize: approvalHistoryMaxResultCount });
  };

  return {
    loading: approvalHistoryLoading,
    // Ordered by the API - re-sorting here would only reach the page on screen and would
    // fight the table's own Sent at column.
    dataSource: Array.from(approvalHistory.values()),
    totalCount: approvalHistoryTotalCount,
    skipCount: approvalHistorySkipCount,
    currentPage: approvalHistoryCurrentPage,
    maxResultCount: approvalHistoryMaxResultCount,
    handlePageChange: handleApprovalHistoryPageChange,
    handleSortChange,
    sorting,
  };
};
